<template>
    <div class="col-lg-7 px-4 wizard-box-left">
        <slot></slot>
    </div>
</template>

<script>
export default {

}
</script>
